/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import AddCardIcon from '@mui/icons-material/AddCard';
import { Box, Button } from '@mui/material';

import { Heading } from 'components/Typography';
import { Datagrid } from 'components/Datatable';
import Loader from 'components/Loader/Loader';
import Layouts from 'layouts';
import {
  Info,
  ModalData,
  balanceLogsColumns,
  useUser,
  requestLogsColumns,
  UserPageFilters,
} from 'features/userPage';

import sliceDate, {
  downloadBlob,
  getRequestTypeArray,
  requestTypeConverter,
  roundFloat,
} from 'utils/helper';

import { HOME_ROUTE } from 'routes/core/RouterConstants';
import Flexbox from 'layouts/flexbox/Flexbox';

const statuses = {
  empty: '-',
  error: 'error',
  success: 'success',
};

const sizeState = 20;

const UserPage = () => {
  const { userId } = useParams();
  const [userInfo, setUserInfo] = useState(null);
  const [balanceHistory, setBalanceHistory] = useState(null);
  const [requestLogs, setRequestLogs] = useState(null);
  const [isOpenModal, setIsModalOpen] = useState(false);

  const [booleanStatusState, setBooleanStatusState] = useState(null);
  const [statusState, setStatusState] = useState(statuses.empty);
  const [requestTypeOption, setRequestTypeOption] = useState([]);
  const [dateRangeState, setDateRangeState] = useState([]);
  const [pageState, setPageState] = useState(0);

  const [typeFilterState, setTypeFilterState] = useState('');

  const [sortState, setSortState] = useState({
    by: 'id',
    order: 'DESC',
  });

  const {
    getDispatchUserInfo,
    getDispatchBalanceHistory,
    isBalanceLogsHistoryFetching,
    isInfoFetching,
    getDispatchRequestLogs,
    isRequestLogsFetching,
    getUserRequestTypesDispatch,
    getLogsReportDisptach,
    getLogsByFilterDispatcher,
  } = useUser();

  useEffect(() => {
    getDispatchUserInfo(userId)
      .unwrap()
      .then((response) => setUserInfo(response));
  }, [isInfoFetching]);

  useEffect(() => {
    const url = `${userId}/request_logs`;
    getDispatchRequestLogs(url)
      .unwrap()
      .then((response) => setRequestLogs(response));
  }, [isRequestLogsFetching]);

  useEffect(() => {
    const url = `${userId}/credit_logs?sort=id%2CDESC`;
    getDispatchBalanceHistory(url)
      .unwrap()
      .then((response) => setBalanceHistory(response));
  }, [isBalanceLogsHistoryFetching]);

  const handleModalOpener = () => {
    setIsModalOpen((state) => !state);
  };

  const handleStatusState = (event) => {
    const value = event.target.value;
    setStatusState(value);

    if (value === statuses.error) {
      setBooleanStatusState(true);
    } else setBooleanStatusState(false);
    // values.exchangeCurrency = value;
  };

  const handleRequestDropdownOpen = () => {
    const url = `${userId}/request_logs_types`;
    getUserRequestTypesDispatch(url)
      .unwrap()
      .then((response) => {
        const types = requestTypeConverter(response);
        setRequestTypeOption(types);
      });
  };

  const handleDateRangeState = (state) => {
    setDateRangeState(state);
  };

  const handleRequestTypeState = (newValue) => {
    setTypeFilterState(newValue);
  };

  const handlePaginationChange = (_event, currentPageNo) => {
    const page = currentPageNo - 1;
    setPageState(page);

    const size = sizeState;
    let queryString = `${userId}/request_logs?page=${page}&size=${size}&sort=${sortState.by},${sortState.order}`;

    if (typeFilterState && typeFilterState.length > 0) {
      const typeArray = getRequestTypeArray(typeFilterState);
      typeArray.forEach((type) => {
        queryString = queryString + `&type=${type}`;
      });
    }

    if (booleanStatusState !== null) {
      const error = booleanStatusState;
      queryString = queryString + `&error=${error}`;
    }

    if (dateRangeState && dateRangeState.length && dateRangeState.length > 0) {
      const fromISODate = dateRangeState[0].toISOString();
      const toISODate = dateRangeState[1].toISOString();
      queryString = queryString + `&from=${fromISODate}&to=${toISODate}`;
    }

    getDispatchRequestLogs(queryString)
      .unwrap()
      .then((respone) => {
        setRequestLogs(respone);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleGoHome = () => {
    window.location.href = HOME_ROUTE;
  };

  const handleFiltering = () => {
    const accountId = userId;
    const page = pageState;
    const size = sizeState;
    let queryString = `?accountId=${accountId}&page=${page}&size=${size}&sort=${sortState.by},${sortState.order}`;

    if (typeFilterState && typeFilterState.length > 0) {
      const typeArray = getRequestTypeArray(typeFilterState);
      typeArray.forEach((type) => {
        queryString = queryString + `&type=${type}`;
      });
    }

    if (booleanStatusState !== null) {
      const error = booleanStatusState;
      queryString = queryString + `&error=${error}`;
    }

    if (dateRangeState && dateRangeState.length && dateRangeState.length > 0) {
      const fromISODate = dateRangeState[0].toISOString();
      const toISODate = dateRangeState[1].toISOString();
      queryString = queryString + `&from=${fromISODate}&to=${toISODate}`;
    }

    getLogsByFilterDispatcher(queryString)
      .unwrap()
      .then((respone) => {
        setRequestLogs(respone);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleExportCSV = () => {
    const accountId = userId;
    const page = pageState;
    const size = sizeState;
    let queryString = `?accountId=${accountId}&page=${page}&size=${size}&sort=${sortState.by},${sortState.order}`;

    if (typeFilterState && typeFilterState.length > 0) {
      const typeArray = getRequestTypeArray(typeFilterState);
      typeArray.forEach((type) => {
        queryString = queryString + `&type=${type}`;
      });
    }

    if (booleanStatusState !== null) {
      const error = booleanStatusState;
      queryString = queryString + `&error=${error}`;
    }

    if (dateRangeState && dateRangeState.length && dateRangeState.length > 0) {
      const fromISODate = dateRangeState[0].toISOString();
      const toISODate = dateRangeState[1].toISOString();
      queryString = queryString + `&from=${fromISODate}&to=${toISODate}`;
    }

    getLogsReportDisptach(queryString)
      .unwrap()
      .then((response) => {
        downloadBlob(response, 'report.csv', 'text/csv;charset=utf-8;');
      })
      .catch((error) => console.log(error));
  };

  const handleSorting = (_event, property) => {
    const isSameOrder = sortState.by === property.by;
    const isAscOrder = sortState.order === 'ASC';

    const isAsc = isSameOrder && isAscOrder;
    const direction = isAsc ? 'DESC' : 'ASC';

    setSortState({
      by: property.by,
      order: direction,
    });

    const accountId = userId;
    const page = pageState;
    const size = sizeState;
    let queryString = `?accountId=${accountId}&page=${page}&size=${size}&sort=${property.by},${direction}`;

    if (typeFilterState && typeFilterState.length > 0) {
      const typeArray = getRequestTypeArray(typeFilterState);
      typeArray.forEach((type) => {
        queryString = queryString + `&type=${type}`;
      });
    }

    if (booleanStatusState !== null) {
      const error = booleanStatusState;
      queryString = queryString + `&error=${error}`;
    }

    if (dateRangeState && dateRangeState.length && dateRangeState.length > 0) {
      const fromISODate = dateRangeState[0].toISOString();
      const toISODate = dateRangeState[1].toISOString();
      queryString = queryString + `&from=${fromISODate}&to=${toISODate}`;
    }

    getLogsByFilterDispatcher(queryString)
      .unwrap()
      .then((respone) => {
        setRequestLogs(respone);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleClearFilters = () => {
    setBooleanStatusState(null);
    setStatusState(statuses.empty);
    setDateRangeState([]);
    setPageState(0);
    setTypeFilterState('');
    setSortState({
      by: 'id',
      order: 'DESC',
    });

    const accountId = userId;
    const page = pageState;
    const size = sizeState;
    let queryString = `?accountId=${accountId}&page=${page}&size=${size}&sort=id,DESC`;

    getLogsByFilterDispatcher(queryString)
      .unwrap()
      .then((respone) => {
        setRequestLogs(respone);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  if (userInfo === null) return <Loader />;
  else
    return (
      <Box>
        <Layouts.Flexbox flexDirection="column">
          <Layouts.Flexbox flexDirection="column" alignItems="flex-start">
            <Layouts.Flexbox mb={3} justifyContent="space-between" width="100%">
              <Heading as="h1" content="User Info:" />
              <Button
                size="large"
                color="success"
                variant="outlined"
                onClick={handleGoHome}
              >
                Go Home
              </Button>
            </Layouts.Flexbox>

            <Info label="Name" content={userInfo.name} />
            <Info label="Email" content={userInfo.email} />
            <Info label="Secret Key" content={userInfo.secret} />
            <Info
              label="Credits left"
              content={roundFloat(userInfo.balance)}
              icon={<AddCardIcon onClick={handleModalOpener} />}
              hasIcon
            />
            <Info label="Created at" content={sliceDate(userInfo.createdAt)} />
          </Layouts.Flexbox>

          <Box mt={5}>
            <Box mb={3}>
              <Heading as="h1" content="Request logs history:" />

              <Flexbox alignItems="end" width="100%" gap="0 10px">
                <UserPageFilters
                  statusFilter={statusState}
                  onStatusChange={handleStatusState}
                  statuses={statuses}
                  dateRangeValue={dateRangeState}
                  onDateRangeChange={handleDateRangeState}
                  typeOptions={requestTypeOption}
                  onRequestTypeDropdown={handleRequestDropdownOpen}
                  requestTypeFilter={typeFilterState}
                  onRequestTypeChange={handleRequestTypeState}
                />

                <Button
                  size="large"
                  color="success"
                  variant="outlined"
                  onClick={handleFiltering}
                  sx={{ textTransform: 'none' }}
                >
                  Apply Filters
                </Button>

                {typeFilterState.length > 0 ||
                statusState !== statuses.empty ||
                (dateRangeState &&
                  dateRangeState.length &&
                  dateRangeState.length > 0) ? (
                  <Button
                    size="large"
                    color="success"
                    variant="outlined"
                    onClick={handleClearFilters}
                    sx={{ textTransform: 'none' }}
                  >
                    Clear Filters
                  </Button>
                ) : null}

                <Button
                  size="large"
                  color="success"
                  variant="contained"
                  onClick={handleExportCSV}
                  sx={{ marginLeft: 'auto', textTransform: 'none' }}
                >
                  Export CSV
                </Button>
              </Flexbox>
            </Box>

            {requestLogs === null ? (
              <Loader />
            ) : (
              <Datagrid
                data={requestLogs.items}
                columnShape={requestLogsColumns}
                hasPagination
                onPaginationChange={handlePaginationChange}
                pages={requestLogs.totalPages}
                pageNumber={requestLogs.page + 1}
                sorting
                onSorting={handleSorting}
                sortBy={sortState.by}
                sortingDirection={sortState.order}
              />
            )}
          </Box>

          <Box mt={5}>
            <Box mb={3}>
              <Heading as="h1" content="Balance logs history:" />
            </Box>

            {balanceHistory === null ? (
              <Loader />
            ) : (
              <Datagrid
                data={balanceHistory.items}
                columnShape={balanceLogsColumns}
              />
            )}
          </Box>
        </Layouts.Flexbox>

        <ModalData
          title="Add Credits"
          isOpen={isOpenModal}
          onClose={handleModalOpener}
          userId={userInfo.id}
        />
      </Box>
    );
};

export default UserPage;
